// The IAM defaults: it builds their links itself, and the dataplane forepaas app has no redirect_uris
const DEFAULT_CLIENT_IDS = ['hq', 'forepaas']

// The application a password reset comes from, or null when it is an IAM default
export const resetPasswordApp = ({ client_id, redirect_uri } = {}) => {
  const isApp = typeof client_id === 'string' && typeof redirect_uri === 'string' &&
    !!client_id && !!redirect_uri && !DEFAULT_CLIENT_IDS.includes(client_id)
  return isApp ? { client_id, redirect_uri } : null
}
